import React from 'react';
import {Dropdown, Icon, MenuListItem, Modal} from '@albert-io/atomic';
import CustomerFeedbackDialogue from 'client/CustomerFeedback/CustomerFeedbackDialogue.react';
import {getBaseUserQuery} from 'client/User/UserQueryUtil';
import sessionStore from 'client/Session/SessionStore';
import {Link} from 'react-router';

import {getDropdownLinks} from '../navLinks';

const DropdownLinks = ({trigger, pathname}: {trigger: React.ReactNode; pathname?: string}) => {
  const [showFeedbackModal, setShowFeedbackModal] = React.useState(false);
  const user = getBaseUserQuery(sessionStore.getUserId()).getResource();
  const firstName = user.getFirstName();
  const filteredLinks = getDropdownLinks();

  const handleFeedbackModalToggle = () => {
    setShowFeedbackModal((prev) => !prev);
  };

  return (
    <>
      <Dropdown
        trigger={trigger}
        position='bottom-end'
        closeOnItemClicked
        wrapperClassName='global-nav-dropdown'
        trayClassName='!z-10 mt-x1 text-nowrap'
        trayProps={{
          modifiers: {
            preventOverflow: {
              padding: 8
            }
          }
        }}
      >
        <div className='flex flex-col gap-x1-half p-x1'>
          {filteredLinks.map((link) => {
            if (!link) return null;

            if (link.get('key') === 'feedback') {
              return (
                <MenuListItem
                  key={link.get('key')}
                  className='nav-submenu_item'
                  onClick={handleFeedbackModalToggle}
                  data-testid={`global-nav__dropdown-link-${link.get('key')}`}
                >
                  {link.get('icon') && (
                    <Icon icon={['fal', link.get('icon', null)]} className='u-mar-r_1' />
                  )}
                  {link.get('name')}
                </MenuListItem>
              );
            }

            let dropdownItem;

            if (link.has('route')) {
              dropdownItem = link.get('hardLink', false) ? (
                <MenuListItem
                  as='a'
                  key={link.get('key')}
                  href={link.get('route')}
                  className='nav-submenu_item'
                  selected={pathname === link.get('route')}
                  data-testid={`global-nav__dropdown-link-${link.get('key')}`}
                >
                  {link.get('icon') && (
                    <Icon icon={['fal', link.get('icon', null)]} className='u-mar-r_1' />
                  )}
                  {link.get('name')}
                </MenuListItem>
              ) : (
                <MenuListItem
                  as={Link}
                  to={link.get('route')}
                  key={link.get('key')}
                  className='nav-submenu_item'
                  selected={pathname === link.get('route')}
                  data-testid={`global-nav__dropdown-link-${link.get('key')}`}
                >
                  {link.get('icon') && (
                    <Icon icon={['fal', link.get('icon', null)]} className='u-mar-r_1' />
                  )}
                  {link.get('name')}
                </MenuListItem>
              );
            } else {
              dropdownItem = (
                <MenuListItem
                  onClick={link.get('action')}
                  key={link.get('key')}
                  className='nav-submenu_item'
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      link.get('action')();
                    }
                  }}
                  data-testid={`global-nav__dropdown-link-${link.get('key')}`}
                >
                  {link.get('icon') && (
                    <Icon icon={['fal', link.get('icon', null)]} className='u-mar-r_1' />
                  )}
                  {link.get('name')}
                </MenuListItem>
              );
            }

            if (link.get('showSeparator', false)) {
              return [dropdownItem, <div className='nav-submenu_border-line' />];
            }
            return dropdownItem;
          })}
        </div>
      </Dropdown>
      {showFeedbackModal && (
        <Modal
          className='customer-feedback-modal'
          ariaLabel='Customer Feedback Modal'
          handleClose={handleFeedbackModalToggle}
          longModal
        >
          {() => (
            <CustomerFeedbackDialogue
              name={firstName}
              handleClose={handleFeedbackModalToggle}
              inModal
            />
          )}
        </Modal>
      )}
    </>
  );
};

export default DropdownLinks;
